<template>
  <div class="edit-table">
    <vxe-toolbar v-if="!disabled">
      <template v-slot:buttons>
        <vxe-button @click="addTable()">添加行</vxe-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      :data="rewardsList"
    >
     <vxe-table-column min-width="100" field="openMinNum" title="最小开瓶数">
        <template #default="{ row }">
            <el-input-number
                v-model="row.openMinNum"
                :disabled="disabled"
                :controls="false"
                :precision="0"
                placeholder="最小开瓶数"
            ></el-input-number>
        </template>
      </vxe-table-column>
       <vxe-table-column min-width="100" field="openMaxNum" title="最大开瓶数">
        <template #default="{ row }">
            <el-input-number
                v-model="row.openMaxNum"
                :disabled="disabled"
                :controls="false"
                :precision="0"
                placeholder="最大开瓶数"
            ></el-input-number>
        </template>
      </vxe-table-column>
      <vxe-table-column min-width="100" field="awardLat" title="奖励纬度">
        <template #default="{ row, rowIndex }">
          <el-select
            v-model="row.awardLat"
            @change="banquetAwardLatTypeChange($event, rowIndex)"
            placeholder="请选择奖励纬度"
            :disabled="disabled"
          >
            <el-option
              v-for="item in banquetAwardLatTypeList"
              :key="item.dictCode"
              :label="item.dictValue"
              :value="item.dictCode"
            >
            </el-option>
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column min-width="100" field="rewardType" title="奖励类型">
        <template #default="{ row, rowIndex }">
          <el-select
            v-model="row.rewardType"
            @change="banquetAwardTypeChange($event, rowIndex)"
            placeholder="请选择奖励类型"
            :disabled="disabled"
          >
            <el-option
              v-for="item in banquetAwardTypeList"
              :key="item.dictCode"
              :label="item.dictValue"
              :value="item.dictCode"
            >
            </el-option>
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column min-width="100" field="cashType" title="兑付方式">
        <template #default="{ row, rowIndex }">
          <el-select
            v-model="row.cashType"
            @change="banquetCashTypeChange($event, rowIndex)"
            placeholder="请选择兑付方式"
            :disabled="disabled"
          >
            <el-option
              v-for="item in banquetCashTypeList"
              :key="item.dictCode"
              :label="item.dictValue"
              :value="item.dictCode"
            >
            </el-option>
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column min-width="100" field="rewardAmount" title="每瓶奖励费用">
        <template #default="{ row }">
            <el-input-number
                v-model="row.rewardAmount"
                :disabled="disabled"
                :controls="false"
                :precision="2"
                placeholder="每瓶奖励费用"
            ></el-input-number>
        </template>
      </vxe-table-column>
      <!-- <vxe-table-column min-width="100" field="openDistance" title="开瓶距离（m）">
        <template #default="{ row }">
            <el-input-number
                v-model="row.openDistance"
                :disabled="disabled"
                :controls="false"
                :precision="2"
                placeholder="开瓶距离（m）"
            ></el-input-number>
        </template>
      </vxe-table-column> -->
      <vxe-column title="操作" width="80" v-if="!disabled">
        <template #default="{ row, rowIndex }">
          <template>
            <span
              @click="deletRow(row, rowIndex)"
              style="color: red; cursor: pointer"
              >删除</span
            >
          </template>
        </template>
      </vxe-column>
    </vxe-table>
  </div>
</template>

<script>
import request from '@/found/utils/request';

export default {
  name: 'scoreRatio',
  components: {},
  props: {
    value: Array,
    disabled: {
      type: Boolean,
      default: () => false,
    },
  },
  watch: {
    value: {
      handler(val) {
        this.rewardsList = val;
      },
      deep: true,
    },
  },
  data() {
    return {
      rewardsList: [], // 当前关联费用科目数据
      banquetCashTypeList: [], // 兑付方式
      banquetAwardTypeList: [], // 奖励类型
      banquetAwardLatTypeList: [], // 奖励纬度
    };
  },
  async created() {
    await this.getDictSelect();
  },
  mounted() {},
  methods: {
    // 获取数据字典
    getDictSelect() {
      request.post('/mdm/mdmdictdata/batchDictSelect', ['banquet_cash_type', 'banquet_award_type', 'banquet_award_lat_type']).then((res) => {
        if (res.success) {
          this.banquetCashTypeList = res.result.banquet_cash_type;
          this.banquetAwardTypeList = res.result.banquet_award_type;
          this.banquetAwardLatTypeList = res.result.banquet_award_lat_type;
        }
      });
    },
    // 删除行
    deletRow(row, rowIndex) {
      console.log(this.rewardsList);
      this.$confirm('您确定要删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.rewardsList.splice(rowIndex, 1);
        this.$emit('change', this.rewardsList);
      });
    },

    // 新增预算信息
    addTable() {
      this.rewardsList.push({
        cashTypeName: null,
        cashType: null,
        // openDistance: 0,
        awardLat: null,
        awardLatName: null,
        openMaxNum: 0,
        openMinNum: 0,
        rewardAmount: 0,
        rewardType: null,
        rewardTypeName: null,
      });

      this.$emit('input', this.rewardsList);
    },
    banquetCashTypeChange(val, index) {
      const res = this.banquetCashTypeList.find(
        (item) => item.dictCode === val,
      );
      this.rewardsList[index].cashTypeName = res.dictValue;
    },
    banquetAwardTypeChange(val, index) {
      const res = this.banquetAwardTypeList.find(
        (item) => item.dictCode === val,
      );
      this.rewardsList[index].rewardTypeName = res.dictValue;
    },
    banquetAwardLatTypeChange(val, index) {
      const res = this.banquetAwardLatTypeList.find(
        (item) => item.dictCode === val,
      );
      this.rewardsList[index].awardLatName = res.dictValue;
    },
  },
};
</script>

<style lang="less" scoped>
.edit-table {
  padding-left: 50px;
  margin-left: 0 !important;
}
.cost-select {
  position: relative;

  /deep/ .el-input__inner {
    padding-right: 30px;
  }

  .clear-icon {
    width: 25px;
    height: 100%;
    position: absolute;
    right: 5px;
    top: 0;
    text-align: center;
    color: #c0c4cc;
    transition: all 0.3s;
    padding-top: 1px;
    display: none;

    .el-icon-circle-close {
      width: 100%;
      font-size: 14px;
      cursor: pointer;
      transition: color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    }
  }

  &:hover {
    .clear-icon {
      display: block;
    }
  }
}
</style>
